const FilterBarSkeleton = ({ withLeagues = true, withDates = true }) => (
  <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-2xl p-2 md:p-3 shadow-sm animate-pulse flex flex-col gap-2">
    {withDates ? <div className="bg-gray-100 dark:bg-gray-700 h-[54px] rounded-xl" /> : null}

    {withLeagues ? (
      <div className="flex items-center gap-2 overflow-hidden">
        {[1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className="bg-gray-100 dark:bg-gray-700 w-20 md:w-24 h-11 rounded-xl shrink-0"
          />
        ))}
      </div>
    ) : null}
  </div>
);

const MatchCardSkeletonItem = () => (
  <div className="bg-white dark:bg-gray-800 rounded-2xl p-3 md:p-4 border border-gray-100 dark:border-gray-700 shadow-sm animate-pulse">
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2 flex-1">
        <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 shrink-0" />
        <div className="h-4 w-16 md:w-24 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
      <div className="w-12 h-3 bg-gray-200 dark:bg-gray-700 rounded mx-2 shrink-0" />
      <div className="flex items-center gap-2 flex-1 justify-end">
        <div className="h-4 w-16 md:w-24 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 shrink-0" />
      </div>
    </div>
    <div className="mb-3 py-1 px-3 rounded-lg bg-gray-50/50 dark:bg-gray-700/30">
      <div className="h-3 w-3/4 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
      <div className="h-3 w-1/2 bg-gray-200 dark:bg-gray-700 rounded" />
    </div>
    <div className="flex justify-between items-center">
      <div className="flex gap-1">
        {[1, 2, 3].map((i) => (
          <div key={i} className="w-8 md:w-10 h-3 bg-gray-200 dark:bg-gray-700 rounded" />
        ))}
      </div>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="w-1.5 h-4 bg-gray-200 dark:bg-gray-700 rounded-full" />
        ))}
      </div>
    </div>
  </div>
);

export const MatchCardsSkeleton = ({ count = 6 }) => (
  <>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
      {Array.from({ length: count }, (_, index) => (
        <MatchCardSkeletonItem key={index} />
      ))}
    </div>
  </>
);

export const PredictionFeedSkeleton = ({ withLeagues = false, withDates = true }) => (
  <div className="pt-2">
    <div className="mb-4">
      <FilterBarSkeleton withLeagues={withLeagues} withDates={withDates} />
      <div className="mt-2 mx-1 h-4 w-40 bg-gray-100 dark:bg-gray-700 rounded animate-pulse" />
    </div>
    {/* 8 cards keep the sections below the feed off the first desktop screen while loading */}
    <MatchCardsSkeleton count={8} />
  </div>
);

export { FilterBarSkeleton };
